import { render, staticRenderFns } from "./PopupView.vue?vue&type=template&id=cfaa4caa&"
import script from "./PopupView.vue?vue&type=script&lang=ts&"
export * from "./PopupView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports